import {
  Card,
  CardBody,
  CardHeader,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import logo from "../../../assets/spazio_tales/logo.png";
import spazioTales from "../../../assets/spazio_tales/spazio_tales.jpg";

export default function SpazioTales() {
  return (
    <Card bg="white" width="100%">
      <CardHeader m="auto">
        <Image src={logo} w={300} title="Spazio Tales" />
      </CardHeader>
      <CardBody>
        <Text>
          Tales va oltre alla manifestazione con <strong>Spazio Tales</strong>!
          <br />
          Vieni a trovarci <strong>ogni Mercoledì alle 21</strong> presso la{" "}
          <strong>
            sede associativa di{" "}
            <Link href={"https://www.diregolarte.it/"}>Di Regola Arte</Link>
          </strong>{" "}
          in{" "}
          <Link href={"https://maps.app.goo.gl/fxTMNJtCEHG8FbRG9"}>
            Via Papa Giovanni XXIII, 15, Montagnana (PD)
          </Link>
          , ex scuola agraria.
          <br />
          Un punto di ritrovo perfetto per poter giocare insieme a{" "}
          <strong>giochi da tavolo o di ruolo</strong>.<br />
          Troverai già molti titoli a disposizione ma puoi proporre sempre le
          tue idee o portare i tuoi giochi!
          <br />
          <strong>
            Contattaci per essere inserito nel gruppo WhatsApp
          </strong>{" "}
          per avere tutte le informazioni e organizzare le serate di gioco.
        </Text>
        <Image src={spazioTales} mt="20px" />
      </CardBody>
    </Card>
  );
}
